module.exports = __webpack_public_path__ + "media/views/builder/sites/assets/CloseButton-3b6924ef488ab4067d9eca76e071ad65.svg";